import React, { Fragment, useCallback } from 'react';
import type { FC } from 'react';

import {
	useAnnotations,
	useAnnotationsDispatch,
} from '@confluence/annotation-provider-store/entry-points/AnnotationsContext.ts';

import { usePreemptiveGate } from '../hooks/usePreemptiveGate.ts';

import { CreateComponent } from './CreateComponent.tsx';
import { ViewComponent } from './ViewComponent.tsx';

export const EditorAnnotationProviderComponents: FC = () => {
	const { editorCreateProps, editorViewProps, isOffline } = useAnnotations();
	const { setEditorCreateProps, setEditorViewProps } = useAnnotationsDispatch();

	const onConfirm = useCallback(() => {
		!!editorCreateProps && setEditorCreateProps(null);
		!!editorViewProps && setEditorViewProps(null);
	}, [editorCreateProps, setEditorCreateProps, editorViewProps, setEditorViewProps]);

	usePreemptiveGate({ onConfirm });

	return (
		<Fragment>
			{editorCreateProps && <CreateComponent {...editorCreateProps} isOffline={isOffline} />}
			{editorViewProps && <ViewComponent {...editorViewProps} isOffline={isOffline} />}
		</Fragment>
	);
};
